import RecurringStatusBlockedModal from '@/components/RecurringEventModal/RecurringStatusBlockedModal';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const RecurringInBlockModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation('RecurringInBlock');

  return (
    <RecurringStatusBlockedModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('title')}
      message={t('message')}
      okLabel={t('ok')}
    />
  );
};

export default RecurringInBlockModal;
